export const UniSender = () => {
  return (
    <>
      <div
        id="unisender-subscribe-form"
        data-url="https://cp.unisender.com/ru/v5/subscribe-form/view/65p5td1hzcrnoggc51dusumgt4b1w5m4fsjw3p4o"
      ></div>
      <script
        type="text/javascript"
        src="https://cp.unisender.com/v5/template-editor-new/js/app/preview/form/form-widget-loader.js"
      ></script>
    </>
  );
};
